<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      line-form
      unit="收入单"
      edit-title
      id-key="DocId"
      :data="data"
      :get-data-func="api.info"
      form-label-width="95px"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @opened="onOpened"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="收入单编号" prop="DocNo">
                <span v-if="Mode == 0" class="detail-span">{{
                  data.DocNo
                }}</span>
                <el-input v-else v-model="data.DocNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  v-model="data.DocDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item
                label="往来单位"
                prop="TradeUnitId"
              >
                <!-- <select-input
                :rules="data.NeedTradeUnit ? tu : null"
                  placeholder="请选择单位"
                  :label="data.TradeUnitName"
                  v-model="data.TradeUnitId"
                  @click="openTradeunit"
                /> -->
                <customer
                  @restaurants="setSupplier"
                  :state="data.TradeUnitName"
                  :typeList="[1, 3]"
                />
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="票据类型" prop="InvoiceTypeId">
                <invoice-select
                  v-model="data.InvoiceTypeId"
                  @change="invoiceChange"
                  @input="invoiceinput"
                  :clearable="false"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="业务类型" prop="BusinessTypeId">
                <business-select
                  v-model="data.BusinessTypeId"
                  :params="{ Kind: '应收', SourceType: '收入单' }"
                  @change="onChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="经办人" prop="ClerkId">
                <select-input
                  placeholder="请选择经办人"
                  :label="data.ClerkName"
                  v-model="data.ClerkId"
                  @click="openEmp"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <el-input
                  type="textarea"
                  v-model="data.Remark"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <template v-if="data.InvoiceTypeId != null">
          <edit-list2 v-if="data.InvoiceTypeName == '收据'" ref="editList" />
          <edit-list1 v-else ref="editList" />
        </template>
        <div class="row-tb-head" style="margin-top: 10px; margin-bottom: 20px">
          <span>收款信息</span>
          <div style="float: right">
            <!-- <el-button size="mini" type="primary" icon="el-icon-plus" @click="addReceipt">添加</el-button> -->
          </div>
        </div>
        <el-table
          border
          class="tb-c-head"
          :data="data.RpIncomeDocReceiptDtos"
          @row-click="rowClick"
        >
          <el-table-column prop="SettleName" label="结算方式" min-width="110">
            <template slot-scope="{ row }">
              <el-select
                size="mini"
                v-model="row.SettleId"
                @change="setSettle(row)"
                placeholder="请选择结算方式"
              >
                <el-option
                  v-for="(i, key) in Settles"
                  :key="key"
                  :label="i.SettleName"
                  :value="i.SettleId"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="AccountName" label="收款账号">
            <template slot-scope="{ row }">
              <select-input
                placeholder="请选择账号"
                :label="row.AccountName"
                v-model="row.AccountId"
                @click="openAccount(row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="ReceiptAmount" label="收款金额">
            <template slot-scope="{ row }">
              <el-input
                size="mini"
                v-model="row.ReceiptAmount"
                @input="onInput(row)"
                placeholder="请输入收款金额"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="95" fixed="right">
            <template slot-scope="{ row, $index }">
              <!-- <el-link style="margin-right:10px" @click="copyRow(row,$index)" :underline="false">复制</el-link> -->
              <el-link @click.stop="delReceipt(row, $index)" :underline="false"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer" slot-scope="{ isLoading }">
        <!-- <el-button type="success" :loading="isLoading" @click="save('submit')">提 交</el-button> -->
        <el-button
          type="primary"
          :loading="isLoading"
          @click="save('save')"
          size="mini"
          >保 存</el-button
        >
        <el-button @click="close" size="mini">关 闭</el-button>
      </template>
      <account-dialog
        ref="accountDialog"
        in-dialog
        selectable
        @select="setAccount"
      />
      <tradeunit-dialog
        ref="tradeunitDialog"
        in-dialog
        selectable
        @select="setTradeunit"
      />
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountDialog from "@/components/basedoc/account/listDialog";
import businessSelect from "@/components/basedoc/business/select";
// import businessSelect from "@/components/common/selectInput";
// import invoiceSelect from "@/components/common/selectInput";
import invoiceSelect from "@/components/basedoc/invoice/select";
// import tradeunitDialog from "@/components/basic/customer/listDialog";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";
// import empDialog from "@/components/ent/emp/listDialog";
import empDialog from "@/components/sales/business/empDialog";
import editList1 from "./editList1";
import editList2 from "./editList2";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountDialog,
    businessSelect,
    invoiceSelect,
    tradeunitDialog,
    empDialog,
    editList1,
    editList2,
    customer,
  },
  data() {
    return {
      api: require("@/api/fund/contactcash/income").default,
      code_api: require("@/api/sy/bill").default,
      settle_api: require("@/api/sale/settle").default,
      income_api: require("@/api/sale/income").default,
      data: {
        DocId: 0,
        DocNo: "", //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        UnitType: 0, //类型 - 1:零售 2:批发 3:供应商
        // DocType: null,
        SourceDocId: null,
        SourceDocNo: "",
        SourceBillName: "",
        BusinessTypeId: null, //业务类型
        InvoiceTypeId: null, //票据类型 - 0:不开票 SY_InvoiceType
        InvoiceTypeName: "",
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        NoTaxAmount: null, //无税金额
        ReceiptAmount: null, //收款税额
        RemainAmount: null, //剩余金额
        Remark: "", //备注
        NeedTradeUnit: true,

        RpIncomeDocDtsDtos: [],
        RpIncomeDocReceiptDtos: [
          {
            DocReceiptId: 0,
            DocId: 0,
            SettleId: null,
            SettleName: "",
            AccountId: null,
            AccountName: "",
            ReceiptAmount: null, //收款金额
            T: 0,
          },
        ],
      },
      Mode: 0,
      DelRpIncomeDocReceiptDtos: [],
      current: null,
      Settles: [], //结算方式列表
      Income: {length:0,Data:[]}, //收入
      isMB: this.$store.state.isMB,
      rules: {
        DocNo: [{ required: true, message: "收入单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        // ClerkId: [{ required: true, message: "请选择经办人" }],
        BusinessTypeId: [{ required: true, message: "请选择业务类型" }],
        InvoiceTypeId: [{ required: true, message: "请选择票据类型" }],
        TradeUnitId: [{ required: true, message: "请选择单位" }],
      },
      //tu: [{ required: true, message: "请选择单位" }],
    };
  },
  methods: {
    setSupplier(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.TradeUnitName;
      this.data.TradeUnitType = data.TradeUnitType;
    },
    onCreateOpened() {
      this.data.RpIncomeDocReceiptDtos = [
        {
          DocReceiptId: 0,
          DocId: 0,
          SettleId: null,
          SettleName: "",
          AccountId: null,
          AccountName: "",
          ReceiptAmount: null, //收款金额
          T: 0,
        },
      ];
      var user = this.$store.state.user;
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.code_api.getDefaultSerialNo("收入单").then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data;
        } else {
          this.$message.warning("获取收入单编号失败");
        }
      });
      // this.addReceipt();
    },
    onEditOpened(data) {
      this.data.RpIncomeDocDtsDtos = this.data.RpIncomeDocDtsDtos.map((x) => {
        // return { ...x, T: null };
        return { ...x, T: 1 };
      });
      this.data.RpIncomeDocReceiptDtos = this.data.RpIncomeDocReceiptDtos.map(
        (x) => {
          // return { ...x, T: null };
          return { ...x, T: 1 };
        }
      );
      if(this.data.RpIncomeDocReceiptDtos.length==0){
        this.data.RpIncomeDocReceiptDtos = [
        {
          DocReceiptId: 0,
          DocId: 0,
          SettleId: null,
          SettleName: "",
          AccountId: null,
          AccountName: "",
          ReceiptAmount: null, //收款金额
          T: 0,
        },
      ];
      }
      this.$nextTick(() => {
        this.$refs.editList.setData(this.data.RpIncomeDocDtsDtos);
        // this.$refs.editList.setIncome(this.Income);
      });
    },
    onOpened() {
      this.settle_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Settles = res.Data;
      });
      this.income_api.list({ Status: 1,pageIndex:1,pageSize:7 }).then((res) => {
        if (res.Code == 0) {this.Income.Data = res.Data;this.Income.length=res.Count;}
      });
    },
    onChange(data) {
      if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
      else this.data.NeedTradeUnit = true;
      this.$refs.dialog.clearValidate();
    },
    invoiceinput(e, data, type) {
      this.$nextTick(() => {
        this.$refs.editList.setIncome(this.Income, data.DefTaxRate, type);
      });
    },
    invoiceChange(e, data, type) {
      //
      let DelData = [];
      if (this.data.InvoiceTypeId != null && this.$refs.editList) {
        this.$refs.editList.Data.forEach((row) => {
          if (row.T != 0) DelData.push({ ...row, T: 2 });
        });
      }
      if (data.InvoiceTypeName != "收据") {
        this.$refs.editList.Data = [
          {
            DocDtsId: 0,
            DocId: 0,
            IncomeId: 0, //收入
            IncomeCode: "",
            IncomeName: "",
            Amount: null, //金额
            TaxRate: this.DefTaxRate, //税率
            TaxAmount: null, //税额
            IncTaxAmount: null, //含税金额
            // NoTaxAmount: null, //无税金额
            // WriteoffAmount: 0, //累计结款金额
            Remark: "",
            T: 0,
          },
        ];
      }
      this.data.InvoiceTypeName = data.InvoiceTypeName;
      this.$nextTick(() => {
        this.$refs.editList.setIncome(this.Income, data.DefTaxRate, type);
        this.$refs.editList.DelData = DelData;
      });
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.data.RpIncomeDocReceiptDtos.indexOf(row);
        if (index + 1 == this.data.RpIncomeDocReceiptDtos.length) {
          //
          this.addReceipt();
        }
      }
    },
    addReceipt() {
      var item = {
        DocReceiptId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        SettleName: "",
        AccountId: null,
        AccountName: "",
        ReceiptAmount: null, //收款金额
        T: 0,
      };
      this.data.RpIncomeDocReceiptDtos.push(item);
    },
    setSettle(row) {
      var settle = this.Settles.find((x) => x.SettleId == row.SettleId);
      row.AccountId = settle.AccountId;
      row.AccountName = settle.AccountName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    openAccount(row) {
      this.current = row;
      this.$refs.accountDialog.open().then((that) => {
        that.getData();
      });
    },
    setAccount(data) {
      this.current.AccountId = data.AccountId;
      this.current.AccountName = data.AccountName;
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.Id;
      this.data.TradeUnitName = data.Name;
      this.data.TradeUnitType = data.TradeUnitType;
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      // row.ReceiptAmount = this.$commonJs.obj.toNumber(row.ReceiptAmount);
      var items = this.data.RpIncomeDocReceiptDtos.filter(
        (x) => !!x.ReceiptAmount
      ).map((x) => x.ReceiptAmount);
      var amount = null;
      if (items.length > 0) {
        amount = items.reduce((a, b) => {
          return a + b;
        });
      }
      this.data.ReceiptAmount = amount;
    },
    delReceipt(row, index) {
      if (row.T != 0) this.DelRpIncomeDocReceiptDtos.push({ ...row, T: 2 });
      if (this.data.RpIncomeDocReceiptDtos.length == 1) {
        this.data.RpIncomeDocReceiptDtos.splice(index, 1);
        this.addReceipt();
      } else {
        this.data.RpIncomeDocReceiptDtos.splice(index, 1);
      }
    },
    save(type) {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        var data = this.$commonJs.obj.removeNullKey(this.data);
        data.RpIncomeDocDtsDtos = this.$refs.editList.Data.filter(
          (x) => x.IncomeId != 0
        );

        // data.RpIncomeDocDtsDtos = this.$refs.editList.Data;
        
        // if (
        //   this.data.RpIncomeDocReceiptDtos.every((x) => !x.SettleId) &&
        //   this.data.RpIncomeDocReceiptDtos.every((x) => !x.AccountId) &&
        //   this.data.RpIncomeDocReceiptDtos.every((x) => !x.ReceiptAmount)
        // ) {
        //   this.$message.warning("收款信息不能为空");
        //   return false;
        // }
        for (let index = 0; index < data.RpIncomeDocDtsDtos.length; index++) {
          if (
            !!data.RpIncomeDocDtsDtos[index].IncomeId ||
            !!data.RpIncomeDocDtsDtos[index].Amount
          ) {
            if (!data.RpIncomeDocDtsDtos[index].IncomeId) {
              this.$message.warning("收入信息 - 收入名称不能为空");
              return;
            }
            if (!data.RpIncomeDocDtsDtos[index].Amount) {
              this.$message.warning("收入信息 - 金额不能为空");
              return;
            }
          }
        }

        if (data.InvoiceTypeName != "收据") {
          var taxRate = data.RpIncomeDocDtsDtos.every((x) => !!x.TaxRate);
          if (!taxRate) {
            this.$message.warning("收入信息 - 税率不能为空");
            return;
          }
          // var taxAmount = data.RpIncomeDocDtsDtos.every((x) => !!x.TaxAmount);
          // if (!taxAmount) {
          //   this.$message.warning("收入信息 - 税额不能为空");
          //   return;
          // }
          // var incTaxAmount = data.RpIncomeDocDtsDtos.every(
          //   (x) => !!x.IncTaxAmount
          // );
          // if (!incTaxAmount) {
          //   this.$message.warning("收入信息 - 含税金额不能为空");
          //   return;
          // }
        }

        if(this.data.RpIncomeDocReceiptDtos.length>0){
          for (
          let index = 0;
          index < data.RpIncomeDocReceiptDtos.length;
          index++
        ) {
          if (
            !!data.RpIncomeDocReceiptDtos[index].SettleId ||
            !!data.RpIncomeDocReceiptDtos[index].AccountId ||
            !!data.RpIncomeDocReceiptDtos[index].ReceiptAmount
          ) {
            if (!data.RpIncomeDocReceiptDtos[index].SettleId) {
              this.$message.warning("收款信息 - 结算方式不能为空");
              return;
            }
            if (!data.RpIncomeDocReceiptDtos[index].AccountId) {
              this.$message.warning("收款信息 - 账号不能为空");
              return;
            }
            if (!data.RpIncomeDocReceiptDtos[index].ReceiptAmount) {
              this.$message.warning("收款信息 - 收款金额不能为空");
              return;
            }
          }
        }
        data.RpIncomeDocReceiptDtos = data.RpIncomeDocReceiptDtos.filter(
          (x) => x.T != null
        );
        data.RpIncomeDocReceiptDtos = data.RpIncomeDocReceiptDtos.filter(
          (x) => x.SettleId != null
        );
        this.DelRpIncomeDocReceiptDtos.forEach((x) => {
          if (x.SettleId != 0) {
            data.RpIncomeDocReceiptDtos.push(x);
          }
        });
        }
        

        var DelRpIncomeDocDtsDtos = this.$refs.editList.DelData;
        data.RpIncomeDocDtsDtos = data.RpIncomeDocDtsDtos.filter(
          (x) => x.T != null
        );
        data.RpIncomeDocDtsDtos.forEach((x) => (x.DocId = this.data.DocId));
        DelRpIncomeDocDtsDtos.forEach((x) => {
          if (x.IncomeId != 0) {
            data.RpIncomeDocDtsDtos.push(x);
          }
        });

      

        this.$refs.dialog.isLoading = true;
        this.api[type](data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.DelRpIncomeDocReceiptDtos = [];
      this.data.RpIncomeDocReceiptDtos = [
        {
          DocReceiptId: 0,
          DocId: 0,
          SettleId: null,
          SettleName: "",
          AccountId: null,
          AccountName: "",
          ReceiptAmount: null, //收款金额
          T: 0,
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
.border {
  padding: 15px;
}
</style>